/* ODVARO: wlasna wyszukiwarka na podstawie listy produktow sklepu.
   Pokazuje pasujace MARKI i PRODUKTY, bez "sugestii" Shopify.
   Gdy nic nie pasuje (np. literowka), wraca do wyszukiwarki Shopify. */
const OV_BRAND_ALIASES = {
  'yves saint laurent': 'ysl saint laurent',
  'dolce gabbana': 'dg dolce gabbana',
  'parfums de marly': 'pdm marly',
  'maison francis kurkdjian': 'mfk kurkdjian',
  'jean paul gaultier': 'jpg gaultier',
  'calvin klein': 'ck',
  'carolina herrera': 'ch herrera',
  'giorgio armani': 'armani',
  'emporio armani': 'armani',
  'hugo boss': 'boss',
  rabanne: 'paco rabanne',
  'maison margiela': 'margiela replica',
  'viktor rolf': 'viktor rolf',
  hermes: 'hermes',
  bvlgari: 'bulgari',
  lancome: 'lancome',
  chloe: 'chloe',
};

function ovNorm(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/ł/g, 'l')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/['’`´°]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

function ovEscape(value) {
  return String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

function ovPlural(n, one, few, many) {
  const m10 = n % 10;
  const m100 = n % 100;
  if (n === 1) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
  return many;
}

const OvSearchIndex = {
  KEY: 'ovSearchIndex-v1',
  TTL: 30 * 60 * 1000,
  items: null,
  ready: false,
  failed: false,
  promise: null,

  root() {
    const url = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    return url.replace(/search\/suggest\/?$/, '');
  },

  prep(raw) {
    const vNorm = ovNorm(raw.v);
    const alias = OV_BRAND_ALIASES[vNorm] || '';
    const vendorTokens = ovNorm(raw.v + ' ' + alias).split(' ').filter(Boolean);
    const titleClean = String(raw.t || '').replace(/\s*-\s*odlewka perfum\s*$/i, '').replace(/\s+/g, ' ').trim();
    const titleTokens = ovNorm(titleClean).split(' ').filter(Boolean);
    const tagTokens = ovNorm(raw.g).split(' ').filter(Boolean);
    return {
      raw,
      title: titleClean,
      titleNorm: ovNorm(titleClean),
      vendorNorm: vNorm,
      vendorTokens,
      titleTokens,
      tagTokens,
    };
  },

  setItems(items) {
    this.items = items.map((raw) => this.prep(raw));
    this.ready = true;
  },

  load() {
    if (this.promise) return this.promise;
    try {
      const cached = JSON.parse(window.sessionStorage.getItem(this.KEY) || 'null');
      if (cached && Array.isArray(cached.items) && Date.now() - cached.ts < this.TTL) {
        this.setItems(cached.items);
        this.promise = Promise.resolve();
        return this.promise;
      }
    } catch (e) {}

    const fetchPage = (page, acc) =>
      fetch(`${this.root()}collections/all?view=ov-search-index&page=${page}`, { credentials: 'same-origin' })
        .then((r) => {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then((text) => {
          const data = JSON.parse(text.trim());
          acc.push(...data.items);
          return data.page < data.pages && page < 10 ? fetchPage(page + 1, acc) : acc;
        });

    this.promise = fetchPage(1, [])
      .then((items) => {
        if (!items.length) throw new Error('empty');
        this.setItems(items);
        try {
          window.sessionStorage.setItem(this.KEY, JSON.stringify({ ts: Date.now(), items }));
        } catch (e) {}
      })
      .catch(() => {
        this.failed = true;
      });
    return this.promise;
  },

  search(query) {
    const words = ovNorm(query).split(' ').filter(Boolean);
    if (!words.length || !this.items) return { brands: [], products: [] };
    const qNorm = words.join(' ');
    const has = (tokens, w) => tokens.some((t) => t.startsWith(w));

    const products = [];
    this.items.forEach((item, index) => {
      let tagOnly = false;
      for (const w of words) {
        const inMain = has(item.vendorTokens, w) || has(item.titleTokens, w);
        if (!inMain) {
          if (has(item.tagTokens, w)) tagOnly = true;
          else return;
        }
      }
      let score = 0;
      if (words.every((w) => has(item.vendorTokens, w))) score += 1000;
      if (item.titleNorm.startsWith(qNorm)) score += 300;
      if (item.titleNorm.includes(qNorm)) score += 100;
      words.forEach((w) => {
        const idx = item.titleTokens.findIndex((t) => t.startsWith(w));
        if (idx >= 0) score += 40 - Math.min(idx, 30);
        if (item.titleTokens.includes(w)) score += 15;
      });
      if (tagOnly) score -= 500;
      if (item.raw.a) score += 5;
      products.push({ item, score, index });
    });
    products.sort((a, b) => b.score - a.score || a.item.title.localeCompare(b.item.title, 'pl'));

    const brandMap = new Map();
    this.items.forEach((item) => {
      if (!words.every((w) => has(item.vendorTokens, w))) return;
      const b = brandMap.get(item.vendorNorm) || { name: item.raw.v, url: item.raw.vu, count: 0 };
      b.count += 1;
      brandMap.set(item.vendorNorm, b);
    });
    const brands = Array.from(brandMap.values()).sort((a, b) => b.count - a.count).slice(0, 3);

    return { brands, products: products.map((p) => p.item) };
  },

  render(query, maxProducts = 8) {
    const { brands, products } = this.search(query);
    if (!products.length && !brands.length) return null;

    const brandHtml = brands.length
      ? `<div class="predictive-search__result-group"><div>
          <h2 id="predictive-search-brands" class="predictive-search__heading text-body caption-with-letter-spacing">Marki</h2>
          <ul id="predictive-search-results-brands-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-brands">
            ${brands
              .map(
                (b, i) => `<li id="predictive-search-option-brand-${i + 1}" class="predictive-search__list-item" role="option" aria-selected="false">
                  <a href="${ovEscape(b.url)}" class="predictive-search__item link link--text" tabindex="-1">
                    <div class="predictive-search__item-content predictive-search__item-content--centered">
                      <p class="predictive-search__item-heading h5">${ovEscape(b.name)}</p>
                      <span class="ov-ps-brand-count">${b.count} ${ovPlural(b.count, 'zapach', 'zapachy', 'zapachów')}</span>
                    </div>
                  </a>
                </li>`
              )
              .join('')}
          </ul>
        </div></div>`
      : '';

    const shown = products.slice(0, maxProducts);
    const productHtml = shown.length
      ? `<div class="predictive-search__result-group"><div>
          <h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing">Produkty</h2>
          <ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-products">
            ${shown
              .map(
                (p, i) => `<li id="predictive-search-option-product-${i + 1}" class="predictive-search__list-item" role="option" aria-selected="false">
                  <a href="${ovEscape(p.raw.u)}" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text" tabindex="-1">
                    ${p.raw.i ? `<img class="predictive-search__image" src="${ovEscape(p.raw.i)}" alt="" width="50" height="50" loading="lazy" style="height:auto">` : ''}
                    <div class="predictive-search__item-content">
                      <p class="predictive-search__item-heading h5">${ovEscape(p.title)}</p>
                      <div class="price"><span class="price-item price-item--regular">od ${ovEscape(p.raw.p)}</span>${p.raw.a ? '' : ' <span class="ov-ps-soldout">niedostępne</span>'}</div>
                    </div>
                  </a>
                </li>`
              )
              .join('')}
          </ul>
        </div></div>`
      : '';

    const total = products.length;
    const allLabel =
      total > shown.length
        ? `Pokaż wszystkie ${total} ${ovPlural(total, 'wynik', 'wyniki', 'wyników')} dla „${ovEscape(query)}”`
        : `Szukaj „${ovEscape(query)}”`;

    return `<div id="predictive-search-results" role="listbox">
      <div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper${brands.length ? '' : ' predictive-search__results-groups-wrapper--no-suggestions'}">
        ${brandHtml}${productHtml}
      </div>
      <div id="predictive-search-option-search-keywords" class="predictive-search__search-for-button">
        <button class="predictive-search__item predictive-search__item--term link link--text h5 animate-arrow" tabindex="-1" role="option" aria-selected="false">
          <span data-predictive-search-search-for-text>${allLabel}</span>
          <span class="svg-wrapper"><svg class="icon icon-arrow" viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></span>
        </button>
      </div>
    </div>
    <span class="hidden" data-predictive-search-live-region-count-value>${total} ${ovPlural(total, 'produkt', 'produkty', 'produktów')}${brands.length ? `, ${brands.length} ${ovPlural(brands.length, 'marka', 'marki', 'marek')}` : ''}</span>`;
  },
};
window.OvSearchIndex = OvSearchIndex;


(function () {
  if (document.getElementById('ov-ps-style')) return;
  const s = document.createElement('style');
  s.id = 'ov-ps-style';
  s.textContent =
    '.ov-ps-brand-count{display:block;font-size:1.2rem;color:rgba(var(--color-foreground),.55);margin-top:.2rem}' +
    '.ov-ps-soldout{font-size:1.2rem;color:rgba(var(--color-foreground),.5)}' +
    '#predictive-search-results-brands-list .predictive-search__item-heading{font-weight:600}';
  (document.head || document.documentElement).appendChild(s);
})();

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
    this.ovEnsureHiddenInputs();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.input.addEventListener('focus', () => window.OvSearchIndex && window.OvSearchIndex.load(), { once: true });
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText && previousTerm) {
      // ODVARO: bezpieczne porownanie (znaki specjalne w frazie nie psuja RegExp)
      const occurrences = currentButtonText.split(previousTerm).length - 1;
      if (occurrences !== 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  // ODVARO: lepsza wyszukiwarka
  // - przerywa poprzednie zapytanie, zeby stare wyniki nie nadpisywaly nowych
  // - wlasny indeks produktow: marki + produkty, bez sugestii Shopify
  // - awaryjnie wyszukiwarka Shopify: do 10 produktow, bez opisow
  // - niedostepne produkty na koncu
  ovQueryKey(searchTerm) {
    return searchTerm.trim().toLowerCase().replace(/\s+/g, '-');
  }

  ovEnsureHiddenInputs() {
    const form = this.input && this.input.form;
    if (!form || form.dataset.ovSearchReady) return;
    form.dataset.ovSearchReady = '1';
    [
      ['type', 'product'],
      ['options[unavailable_products]', 'last'],
    ].forEach(([name, value]) => {
      if (form.querySelector(`input[name="${name}"]`)) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });
  }

  ovTrimResults(markup) {
    const doc = new DOMParser().parseFromString(`<div id="ov-root">${markup}</div>`, 'text/html');
    const root = doc.getElementById('ov-root');
    root.querySelectorAll('[id^="predictive-search-option-query-"]').forEach((el) => el.remove());
    root.querySelectorAll('[id^="predictive-search-option-collection-"]').forEach((el, i) => {
      if (i >= 3) el.remove();
    });
    const heading = root.querySelector('#predictive-search-queries');
    if (heading) heading.textContent = 'Kolekcje';
    return root.innerHTML;
  }

  getSearchResults(searchTerm) {
    this.ovEnsureHiddenInputs();
    const queryKey = this.ovQueryKey(searchTerm);
    const idx = window.OvSearchIndex;

    // ODVARO: najpierw wlasna wyszukiwarka (marki + produkty)
    if (idx && !idx.failed) {
      if (idx.ready) {
        const local = idx.render(searchTerm);
        if (local) {
          this.abortController.abort();
          this.abortController = new AbortController();
          this.setLiveRegionLoadingState();
          this.renderSearchResults(local);
          return;
        }
      } else {
        this.setLiveRegionLoadingState();
        idx.load().then(() => {
          if (this.ovQueryKey(this.getQuery()) === queryKey) this.getSearchResults(searchTerm);
        });
        return;
      }
    }

    // Brak dokladnych trafien (np. literowka) -> wyszukiwarka Shopify
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    this.abortController.abort();
    this.abortController = new AbortController();

    const params = new URLSearchParams();
    params.set('q', searchTerm);
    params.set('section_id', 'predictive-search');
    params.set('resources[type]', 'product,collection');
    params.set('resources[limit]', '10');
    params.set('resources[limit_scope]', 'each');
    params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
    params.set('resources[options][unavailable_products]', 'last');

    fetch(`${routes.predictive_search_url}?${params.toString()}`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const section = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search');
        if (!section) return;
        const resultsMarkup = this.ovTrimResults(section.innerHTML);
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        // Pokaz tylko, jesli to wciaz aktualnie wpisana fraza
        if (this.ovQueryKey(this.getQuery()) !== queryKey) return;
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20 || error?.name === 'AbortError') {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    const countEl = this.querySelector('[data-predictive-search-live-region-count-value]');
    if (countEl) this.setLiveRegionText(countEl.textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
